import styled, { css } from 'styled-components';
import { getIconUrl, pxToRem } from '@anwb/style-utilities';
export const ICON_SIZES = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 22,
    xxl: 28,
    xxxl: 34,
    jumbo: 40,
    'jumbo-xl': 50,
    'jumbo-xxl': 60,
    'jumbo-xxxl': 70,
    mega: 80,
};
export const iconContainerStyles = ({ theme, $size, $type, $variant, }) => {
    const size = typeof $size === 'string' ? { initial: $size } : $size;
    const breakpoints = Object.keys(size).filter((key) => key !== 'initial');
    return css `
		background-color: currentColor;
		display: inline-block;
		mask: url(${getIconUrl($variant, $type)}) no-repeat center right;
		min-height: ${pxToRem(ICON_SIZES[size.initial])};
		width: ${pxToRem(ICON_SIZES[size.initial])};

		${breakpoints.map((breakpoint) => {
        return css `
				@media (min-width: ${pxToRem(theme.viewportBreakpoint[breakpoint])}) {
					min-height: ${pxToRem(ICON_SIZES[size[breakpoint]])};
					width: ${pxToRem(ICON_SIZES[size[breakpoint]])};
				}
			`;
    })}
	`;
};
export const IconContainer = styled.span `
	${iconContainerStyles}
`;
//# sourceMappingURL=icon.styled.js.map